var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object-details-template',{attrs:{"offer-object":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [(_vm.currentOffer)?_c('object-offer-header',{attrs:{"content":_vm.object,"offer":_vm.currentOffer}}):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }